import { css as t } from "@microsoft/fast-element";
import { normalize as s } from "../../common/normalize.js";
import { display as a, PropertyStyleSheetBehavior as n } from "@matrix42/fast-foundation";
import { designTokens as o } from "../../design-tokens.js";
import { PropertiesStylesheetBehavior as l } from "../../common/behaviors/properties-stylesheet-behavior.js";
import { typography as c } from "../../styles/typography.js";
function e(r, i) {
  return new n("variant", r, i);
}
const p = t`
  .control {
    /* Style */
    border-color: ${o.color.primary[60]};
  }

  .variant-icon {
    /* Style */
    color: ${o.color.primary[100]};
  }
`, d = t`
  .control {
    /* Style */
    border-color: ${o.color.error[60]};
  }

  .variant-icon {
    /* Style */
    color: ${o.color.error[100]};
  }
`, $ = t`
  .control {
    /* Style */
    border-color: ${o.color.success[60]};
  }

  .variant-icon {
    /* Style */
    color: ${o.color.success[100]};
  }
`, y = t`
  .control {
    /* Layout */
    padding-right: ${o.spacing[14]};
  }
`, f = (r) => t`
    ${s}
    ${a("flex")}
    :host {
      /* Base */
      pointer-events: all;
      user-select: none;
    }

    .control {
      /* Base */
      position: relative;
      /* Layout */
      display: inline-flex;
      padding: ${o.spacing[4]} ${o.spacing[10]}
        ${o.spacing[4]} ${o.spacing[4]};
      align-items: flex-start;
      align-content: flex-start;
      gap: ${o.spacing[2]};
      max-width: calc(40 * ${o.spacing[4]});
      /* Style */
      border-radius: ${o.borderRadius.sm};
      background-color: ${o.color.neutral[30]};
      border: ${o.borderWidth.xs} solid ${o.color.black};
      box-shadow: ${o.shadow.box.lg};
    }

    .content {
      /* Style */
      color: ${o.color.neutral[400]};
      /* Typography */
      ${c("p", "semibold")}
    }

    .dismiss-button {
      /* Layout */
      position: absolute;
      top: ${o.spacing[2]};
      right: ${o.spacing[2]};
    }

    .duration-timer {
      /* Layout */
      position: absolute;
      bottom: ${o.spacing[4]};
      right: ${o.spacing[4]};
    }

    ${r.prefix}-icon,
    ::slotted(${r.prefix}-icon) {
      /* Layout */
      width: ${o.iconSize.md} !important;
      height: ${o.iconSize.md} !important;
      flex-shrink: 0;
      /* Style */
      color: inherit;
    }

    ::slotted(${r.prefix}-avatar) {
      /* Layout */
      width: ${o.spacing[6]} !important;
      height: ${o.spacing[6]} !important;
      flex-shrink: 0;
    }
  `.withBehaviors(
  e("info", p),
  e("error", d),
  e("success", $),
  new l(
    ["dismissible", "duration"],
    (i) => i.dismissible || i.duration > 0,
    y
  )
);
export {
  f as toastStyles
};
